/* eslint-disable no-console */
import { useEffect } from 'react';
export function useLogger(name, props) {
    useEffect(() => {
        console.log(`${name} has mounted`);
        return () => console.log(`${name} has unmounted`);
    }, [name]);
    useEffect(() => {
        console.log('Props updated', props);
    });
}
export default useLogger;
//# sourceMappingURL=useLogger.js.map